import { Payment } from "../payment";

export class PaymentMethodValidationRequest {
    customerCode: string;
    condition: string;
    salesOrg: string;
    branchCode: string;
    payments: Array<Payment>;

    constructor() {
        this.customerCode = "";
        this.condition = "";
        this.salesOrg = "";
        this.branchCode = "";
        this.payments = [];
    }
}